<template>
  <div class="video">
    <div>
      <img v-if="!currentVideo.thumbnail" src="../../../assets/thumbnail.svg" />
      <b-img
        v-if="currentVideo.thumbnail"
        :src="currentVideo.thumbnail"
        height="120"
        width="210"
      ></b-img>
      <div class="video__duration">
        {{ convertToMins(currentVideo.duration) }}
      </div>
    </div>
    <div class="video__upload-date">
      Upload on {{ toDateFormat(currentVideo.uploadDate) }}
    </div>
    <div class="video__checkbox-upcoming">
      <b-form-checkbox
        :id="'video__checkbox-upcoming' + currentVideo.id"
        v-b-tooltip.hover
        title="Set as upcoming"
        v-model="currentVideo.isUpcoming"
        switch
        :disabled="currentVideo.isActive"
        size="sm"
        @input="changeVideoIsUpcoming($event)"
      ></b-form-checkbox>
    </div>
    <div class="video__checkbox" @click="showCheckboxToast">
      <b-form-checkbox
        :id="'video__checkbox-' + currentVideo.id"
        v-b-tooltip.hover
        :title="currentVideo.isActive ? 'Deactivate' : 'Activate'"
        v-model="currentVideo.isActive"
        switch
        size="sm"
        :disabled="!(currentVideo.data && currentVideo.instructorPoseCount > 0)"
        @input="changeVideoIsActive($event)"
      ></b-form-checkbox>
    </div>
    <div class="video__title">{{ currentVideo.title }}</div>
    <div class="video_status">{{ currentVideo.videoStatus }}</div>
    <div class="video__upload-by">By {{ currentVideo.uploadBy }}</div>
    <span class="video__editicon" :id="'edit-' + currentVideo.id">
      <i
        class="icon-more_vert"
        v-b-tooltip.hover
        @click="editVideo(currentVideo.id)"
      ></i>
    </span>
    <b-tooltip
      :target="'edit-' + currentVideo.id"
      triggers="hover"
      placement="left"
    >
      Edit
    </b-tooltip>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/videosView");
import toast from "../../toaster.js";

export default {
  data: function () {
    return {
      src: null,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  props: {
    video: {
      type: Object,
    },
  },

  computed: {
    currentVideo() {
      return JSON.parse(JSON.stringify(this.video));
    },
  },

  methods: {
    ...mapActions(["setVideoActiveState"]),

    editVideo(id) {
      this.$router.push("videos/edit/" + id);
    },

    convertToMins(durationSecs) {
      durationSecs = parseInt(durationSecs);
      var hours = Math.floor(durationSecs / 3600);
      var minutes = Math.floor((durationSecs - hours * 3600) / 60);
      var seconds = durationSecs - hours * 3600 - minutes * 60;
      if (hours == 0) {
        return ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
      }

      return (
        ("0" + hours).slice(-2) +
        ":" +
        ("0" + minutes).slice(-2) +
        ":" +
        ("0" + seconds).slice(-2)
      );
    },

    showCheckboxToast() {
      if (
        !(this.currentVideo.data && this.currentVideo.instructorPoseCount > 0)
      ) {
        toast.showToasts(
          this,
          "Please add video data and instructor pose details",
          "danger"
        );
      }
    },

    changeVideoIsActive(event) {
      if (this.currentVideo.data && this.currentVideo.instructorPoseCount > 0) {
        let videoData = this.currentVideo;
        videoData.isActive = event;
        if (event) {
          videoData.isUpcoming = false;
        }
        this.setVideoActiveState(videoData);
      }
    },

    changeVideoIsUpcoming(event) {
      let videoData = this.currentVideo;
      videoData.isUpcoming = event;
      this.setVideoActiveState(videoData);
    },

    toDateFormat(uploadDate) {
      const date = new Date(uploadDate);
      return (
        this.months[date.getMonth()] +
        " " +
        date.getDate() +
        " " +
        date.getFullYear()
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.video {
  width: 250px;
  height: 230px;
  float: left;
  padding: 12px;
  display: table;
  text-transform: capitalize;
}

.video__title {
  font-size: 14px;
  font-weight: 600;
}

.video__duration {
  background-color: #505050;
  color: white;
  width: 18%;
  bottom: 25px;
  right: 10%;
  position: relative;
  font-size: 12px;
  float: right;
  text-align: center;
}

.video__upload-by {
  width: 90%;
  font-size: 14px;
  color: black;
  float: left;
}

.video__upload-date {
  float: left;
  font-size: 12px;
  width: 82%;
  color: orange;
}

.video__checkbox {
  float: right;
}

.video__checkbox-upcoming {
  float: right;
}

.video_status{
  width: 90%;
  font-size: 14px;
  color: black;
  float: left;
}

.video__editicon {
  cursor: pointer;
}
</style>